<template>
	<v-card tile elevation="0" style="height: 100vh; overflow-y: hidden">
		<v-card-title class="card-header text-left fixed-card-title2">
			<v-row no-gutters>
				<v-col cols="10">
					<v-toolbar-title>{{ $t('edit-social-determinants-header') }}</v-toolbar-title>
				</v-col>
				<v-spacer />
				<v-icon @click="closeDrawer" class="white-icon">mdi-close</v-icon>
			</v-row>
		</v-card-title>
		<v-card-text class="overflow-auto pt-4 pb-1 px-5" style="height: calc(100vh - 205px)">
			<v-card height="100%" class="overflow-y-auto">
				<v-row dense class="ma-0">
					<v-col v-for="item in workingSocialDeterminantsData" :key="item.id" cols="12">
						<v-checkbox
							v-model="item.flag"
							color="primary"
							:label="$t(item.value)"
							hide-details
							class="ma-0 px-0 py-2" />
					</v-col>
				</v-row>
			</v-card>
		</v-card-text>
		<v-container class="px-4">
			<v-row dense class="ma-0">
				<v-col cols="12">
					<InputTimeFormatter
						:inputValue="timeSpentSeconds"
						@update:inputValue="(val) => (timeSpentSeconds = val)"
						:inputLabel="$t('time-spent')" />
				</v-col>
			</v-row>
			<v-row dense class="ma-0">
				<v-col cols="6" order="1">
					<v-btn @click="closeDrawer()" color="secondary" style="color: black" block>{{ $t('cancel') }}</v-btn>
				</v-col>
				<v-tooltip left v-if="!timeSpentSeconds || timeSpentSeconds > 7200">
					<template v-slot:activator="{ on, attrs }">
						<v-col cols="6" v-bind="attrs" v-on="on" order="2">
							<v-btn disabled block>{{ $t('update') }}</v-btn>
						</v-col>
					</template>
					<span>{{ $t('fill-all-fields-warning') }}</span>
				</v-tooltip>
				<v-col cols="6" v-else order="2">
					<v-btn @click="editSocialDeterminants()" color="dark_purple" style="color: white" block>
						{{ $t('update') }}
					</v-btn>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import InputTimeFormatter from '../Client/components/InputTimeFormatter.vue';
export default {
	name: 'CCMSocialDeterminantsEdit',
	components: { InputTimeFormatter },
	data () {
		return {
			timeSpentSeconds: 0,
			workingSocialDeterminantsData: null,
			complexDecisionMakingData: null,
			socialDeterminantsData: null,
		};
	},
	computed: {
		...mapState({
			currentRecord: (state) => state.ccmRecords.ccmRecord,
			userData: (state) => state.authentication.userData,
		}),

		...mapGetters({ userFullName: 'authentication/getFullName' }),
	},

	methods: {
		...mapActions({
			updateSocialDeterminants: 'ccmRecords/updateSocialDeterminants',
			getSocialDeterminantsTemplate: 'ccmRecords/getSocialDeterminantsTemplate',
		}),
		closeDrawer () {
			this.timeSpentSeconds = 0;
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', false);
			this.$store.commit('SET_EDIT_DETAILS_DRAWER', false);
		},
		async getSocialDeterminantsData () {
			let rawData;
			try {
				rawData = JSON.parse(this.currentRecord.socialDeterminants);
			} catch (e) {
				rawData = null;
			}
			if (!rawData) {
				const response = await this.getSocialDeterminantsTemplate();
				return response.data;
			}
			return rawData;
		},
		editSocialDeterminants () {
			const socialDeterminants = {
				id: this.currentRecord.id,
				body: {
					hospitalId: this.currentRecord.hospitalId,
					providerId: this.currentRecord.providerId,
					coordinatorId: this.currentRecord.coordinatorId,
					socialDeterminants: JSON.stringify(this.workingSocialDeterminantsData),
					lastModifiedBy: `${this.userData.firstName} ${this.userData.lastName}`,
					timeSpentSeconds: this.timeSpentSeconds,
				},
			};
			this.$store.commit('ccmRecords/UPDATE_CCM_RECORD', {
				socialDeterminants: JSON.stringify(this.workingSocialDeterminantsData),
			});
			this.updateSocialDeterminants(socialDeterminants);
			this.closeDrawer();
		},
	},
	async mounted () {
		this.workingSocialDeterminantsData = await this.getSocialDeterminantsData();
	},
	watch: {
		currentRecord: {
			async handler () {
				this.socialDeterminantsData = await this.getSocialDeterminantsData();
			},
			deep: true,
			immediate: true,
		},
	},
};
</script>
